// @flow
import Cup from "./Cup";
import LineCup from "./LineCup";
import ColorfulCup from "./ColorfulCup";
import FinalCup, { WinnerCup } from "./FinalCup";
import Timer from "./Timer";
import Wallet, { WalletPlus } from "./Wallet";
import Rating, { Podium } from "./Rating";
import Person from "./Person";
import Coins, { CoinsPlus } from "./Coins";
import DownArrow from "./DownArrow";
import PaymentError from "./PaymentError";
import Caution from "./Caution";

export {
  DownArrow,
  Cup,
  LineCup,
  ColorfulCup,
  WinnerCup,
  FinalCup,
  Timer,
  Wallet,
  WalletPlus,
  Rating,
  Podium,
  Coins,
  CoinsPlus,
  Person,
  PaymentError,
  Caution
};



// WEBPACK FOOTER //
// ./src/components/Icons/Tournaments/index.js